import { css, ThemeProvider as EmotionThemeProvider } from '@emotion/react'
import React, { memo } from 'react'

import { MediaContextProvider } from './media'

export type Theme = typeof theme

export const theme = {
  colors: {
    variants: {
      primaryLight: '#ffffff',
      neutralLight1: '#FFFBF6',
      neutralLight2: '#F2EFEF',
      neutralLight3: '#643B27',
      neutralLight4: '#F6F2EC',
      primaryDark: '#242424',
      neutralDark1: '#3B3B3B',
      danger: '#ED0F36',
    },
  },
  fontFamily: {
    heading: "'Prata', serif",
    paragraph: "'Lato', sans-serif",
    label: "'Lato', sans-serif",
  },
}

export type Styles = typeof styles

export const styles = {
  h1: css`
    color: ${theme.colors.variants.primaryDark};
    font-family: ${theme.fontFamily.heading};
    font-weight: normal;
    font-size: 3.75rem;

    @media (max-width: 1199px) {
      font-size: 3.125rem;
    }
    @media (max-width: 767px) {
      font-size: 2.5rem;
    }
  `,
  h2: css`
    color: ${theme.colors.variants.primaryDark};
    font-family: ${theme.fontFamily.heading};
    font-weight: normal;
    font-size: 2.5rem;
    line-height: 3.875rem;

    @media (max-width: 1199px) {
      font-size: 1.875rem;
      line-height: 2.5rem;
    }
  `,
  h3: css`
    color: ${theme.colors.variants.primaryDark};
    font-family: ${theme.fontFamily.heading};
    font-weight: normal;
    font-size: 1.875rem;
    line-height: 2.5rem;
  `,
  label: css`
    display: flex;
    align-items: center;
    margin-bottom: 2.5rem;
    color: ${theme.colors.variants.primaryDark};
    font-family: ${theme.fontFamily.label};
    font-weight: 600;
    font-size: 0.8125rem;
    letter-spacing: 0.1em;
    line-height: 1.125rem;
    text-align: left;
    text-transform: uppercase;

    &::before {
      content: '';
      display: block;
      width: 9.25rem;
      height: 0.0625rem;
      margin-right: 0.8125rem;
      background: ${theme.colors.variants.primaryDark};

      @media (max-width: 1199px) {
        width: 3.125rem;
      }
    }
  `,
  description: css`
    color: ${theme.colors.variants.neutralDark1};
    font-family: ${theme.fontFamily.paragraph};
    font-weight: normal;
    font-size: 1.125rem;
    line-height: 1.8125rem;

    @media (max-width: 1199px) {
      font-size: 1.125rem;
      line-height: 1.6875rem;
    }
  `,
}

export const ThemeProvider = memo(function ThemeProvider({ children }: any) {
  return (
    <EmotionThemeProvider theme={theme}>
      <MediaContextProvider>{children}</MediaContextProvider>
    </EmotionThemeProvider>
  )
})
